import React from 'react'

export function TitleBarSubTextContainer({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return (
    <div className={'opacity-60 contrast-more:opacity-100 flex gap-1'}>
      {children}
    </div>
  )
}
